// Coalesce pending work without extending its first deadline. Repeated inputs
// cannot starve an update, and cancellation drops both the timer and its data.
export function createScheduledLatest<T>(delay: number, run: (value: T) => void) {
    let timer: ReturnType<typeof setTimeout>, latest: T
    let pending = false
    const cancel = () => {
        if (pending) clearTimeout(timer)
        pending = false
        latest = undefined
    }
    return {
        schedule(value: T) {
            latest = value
            if (pending) return
            pending = true
            timer = setTimeout(() => {
                const value = latest
                pending = false
                latest = undefined
                run(value)
            }, delay)
        },
        cancel,
    }
}
